import { Component, OnInit, Inject, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MainService } from 'src/app/services/main.service';
import { ProjectsService } from 'src/app/services/projects.service';
import Swal from 'sweetalert2';
import { ProjectAddPlantillaComponent } from '../project-add-plantilla/project-add-plantilla.component';

@Component({
  selector: 'app-project-diagramation-import-vobos',
  templateUrl: './project-diagramation-import-vobos.component.html',
  styleUrls: ['./project-diagramation-import-vobos.component.scss']
})
export class ProjectDiagramationImportVobosComponent implements OnInit {
  @ViewChildren('searchInput') searchInputs!: QueryList<ElementRef<HTMLInputElement>>;

  diagram: any;
  phases: any[] = [];
  project: any;

  plantillas: { id: number, nombre: string, phases_vobos: any }[] = [];
  plantillaSeleccionada: number = 0;
  id_plantSel: number = 0;
  arrPlantilla: any;
  alertEditPlantilla: boolean = false;

  totalPhasesConfiguradas: number = 0;
  selectedVobos: boolean = false;
  secondDataLoaded: boolean = false;
  loaded: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ProjectDiagramationImportVobosComponent>,
    private projectsS: ProjectsService,
    private main: MainService,
    private matDialog: MatDialog
  ) {
    this.diagram = this.data.diagram;
    this.phases = JSON.parse(JSON.stringify(this.data.phases)); // Deep copy
    this.project = this.data.project;
  }

  ngOnInit(): void {
    this.initializeVobos();
    this.getPlantillas(1);
    this.secondDataLoaded = true;
    this.loaded = true;
  }

  initializeVobos() {
    this.phases.forEach(phase => {
      phase.vobos.forEach((vobo: any) => {
        const existingVobo = this.diagram.config_vobos?.find((p: any) => p.id === phase.id)?.vobos.find((v: any) => v.id === vobo.id);
        vobo.selectedUsers = existingVobo ? existingVobo.users : (vobo.users.length === 1 ? [vobo.users[0].id] : []);
        vobo.searchTerm = '';
        vobo.filteredUsers = [...vobo.users];
      });
    });
    this.validateAllVobos();
  }

  onUserSelectionChange(phaseId: number): void {
    this.validateAllVobos();
  }

  validateAllVobos() {
    this.phases.forEach(phase => {
      phase.selected = phase.vobos.every((vobo: any) => vobo.optional == true || (vobo.selectedUsers && vobo.selectedUsers.length > 0));
      const totalSelected = phase.vobos.filter((vobo: any) => vobo.optional == true || (vobo.selectedUsers && vobo.selectedUsers.length > 0)).length;
      phase.totalVobosSelected = totalSelected;
    });

    this.totalPhasesConfiguradas = this.phases.filter(p => p.selected).length;
    this.selectedVobos = this.phases.every(p => p.selected);
  }

  saveVobos() {
    const config_vobos = this.phases.map((phase: any) => ({
      id: phase.id,
      vobos: phase.vobos.map((vobo: any) => ({
        id: vobo.id,
        users: vobo.selectedUsers,
        area: vobo.area,
        optional: vobo.optional
      }))
    }));
    this.dialogRef.close(config_vobos);
  }


  filterUsers(item: any) {
    const term = (item.searchTerm || '').toLowerCase();
    const selectedIds = item.selectedUsers || [];
    const selectedUsers = item.users.filter((u: any) => selectedIds.includes(u.id));
    const filtered = item.users.filter((u: any) => !selectedIds.includes(u.id) && u.name.toLowerCase().includes(term));
    item.filteredUsers = [...selectedUsers, ...filtered];
  }

  clearSearch(item: any): void {
    item.searchTerm = '';
    item.filteredUsers = [...item.users];
  }

  onSelectOpened(index: number) {
    setTimeout(() => {
      const input = this.searchInputs.toArray()[index];
      input?.nativeElement?.focus();
    }, 0);
  }

  toggleSelectAllUsers(item: any, phaseId: number) {
    const allUserIds = item.users.map((u: any) => u.id);
    const allSelected = allUserIds.every((id: number) => item.selectedUsers.includes(id));

    if (allSelected) {
      item.selectedUsers = [];
    } else {
      item.selectedUsers = [...allUserIds];
    }
    this.onUserSelectionChange(phaseId);
    this.filterUsers(item);
  }

  goToConfig() {
    const url = '/admin/projects/config/' + this.project.id;
    window.open(url, '_blank');
  }

  openModalAddPlantilla() {
    this.matDialog.open(ProjectAddPlantillaComponent, {
      panelClass: ['dialogs-md'],
      data: {
        phases: this.phases,
        id_proy: this.project.id
      }
    }).afterClosed().subscribe(resp => {
      this.getPlantillas(2);
      if (resp) {
        this.plantillaSeleccionada = resp;
        this.id_plantSel = resp;
      }
    });
  }

  getPlantillas(tipo: number) {
    this.projectsS.getPlantillasVobos(this.project.id).subscribe(
      (result: any) => {
        this.plantillas = result.data;
      },
      (err: any) => {
        console.log(err);
        Swal.fire({ icon: 'error', title: 'Error al obtener plantillas', text: 'Ocurrió un error al obtener las plantillas' });
      }
    );
  }

  cargaVobosPlantilla(idpl: number) {
    this.arrPlantilla = [];
    this.id_plantSel = idpl;
    const resultado = this.plantillas.find((obj: any) => obj.id === idpl);
    if (resultado) {
      this.arrPlantilla = JSON.parse(resultado.phases_vobos);
    }

    this.phases.forEach((obj1: any) => {
      const obj2 = this.arrPlantilla.find((o: any) => o.id === obj1.id);
      if (obj2) {
        obj1.vobos.forEach((vobo1: any) => {
          const vobo2 = obj2.vobos.find((v: any) => v.area === vobo1.area);
          if (vobo2) {
            vobo1.selectedUsers = vobo2.selectedUsers;
          }
        });
      }
    });
    this.validateAllVobos();
  }

  actualizarPlantilla() {
    this.projectsS.updatePlantillaVobos(this.id_plantSel, this.phases).subscribe(
      (result: any) => {
        if (result.message == "Success") {
          Swal.fire({ icon: 'success', title: 'Actualizada', text: '' }).then(() => {
            this.getPlantillas(2);
            this.alertEditPlantilla = true;
          });
        }
      },
      (err: any) => {
        console.log(err);
        Swal.fire({ icon: 'error', title: 'Error al actualizar plantilla', text: 'Ocurrió un error al actualizar plantilla' });
      }
    );
  }

  eliminarPlantilla() {
    this.projectsS.deletePlantillaVobos(this.id_plantSel).subscribe(
      (result: any) => {
        if (result.message == "Success") {
          Swal.fire({ icon: 'success', title: 'Eliminada', text: '' }).then(() => {
            this.getPlantillas(2);
            this.plantillaSeleccionada = 0;
            this.id_plantSel = 0;
          });
        }
      },
      (err: any) => {
        console.log(err);
        Swal.fire({ icon: 'error', title: 'Error al eliminar plantilla', text: 'Ocurrió un error al eliminar plantilla' });
      }
    );
  }
}
